import { getSelectedCargo, getSelectedTrip } from "./voyageSelection";
import {
  getVoyageNumber,
  getShipPumpCapacity,
  getShipDeadWeight,
} from "./domainSelectors";

const getPrefillValue = (
  label,
  currentVoyage,
  selectedTripId,
  selectedCargoIndex,
  shipData
) => {
  const trip = getSelectedTrip(currentVoyage, selectedTripId);
  if (!trip) return "";
  const cargo =
    getSelectedCargo(currentVoyage, selectedTripId, selectedCargoIndex) || {};
  const activities = cargo.activities || {};

  switch (label) {
    case "Voy":
      return getVoyageNumber(currentVoyage);
    case "To":
      return trip.supplierReceiver;
    case "Port":
      return trip.to;
    case "Date":
      return trip.date || "";
    case "C/P Date":
      return trip.cpDated || "";
    case "Vessel arrived":
      return (
        (activities.eosp?.date || "") + " " + (activities.eosp?.time || "")
      );
    case "Notice of Readiness tendered":
      return (
        (activities["nor-tendered"]?.date || "") +
        " " +
        (activities["nor-tendered"]?.time || "")
      );
    case "Loading commenced":
      return (
        (activities["commenced-load"]?.date || "") +
        " " +
        (activities["commenced-load"]?.time || "")
      );
    case "Hose/Arms disconnected":
      return (
        (activities["disconnected"]?.date || "") +
        " " +
        (activities["disconnected"]?.time || "")
      );
    case "Documents onboard":
      return (
        (activities["documents-onboard"]?.date || "") +
        " " +
        (activities["documents-onboard"]?.time || "")
      );
    case "Documents duly signed":
      return (
        (activities["documents-signed"]?.date || "") +
        " " +
        (activities["documents-signed"]?.time || "")
      );
    case "Grade":
      return cargo.cargo || "";
    case "B/L Figure":
      return activities["ullage-sampling"]?.remarks?.blfig || "";
    case "B/L Date":
      return activities["ullage-sampling"]?.date || "";
    case "Ship Figure":
      return activities["completed-load"]?.remarks?.shipfig || "";
    case "Bunkers":
      return (
        (parseFloat(activities["changed-pilot"]?.remarks?.lng) || 0) +
          (parseFloat(activities["changed-pilot"]?.remarks?.go) || 0) || ""
      );
    case "Ship loading":
      return getShipPumpCapacity(shipData)
        ? `${getShipPumpCapacity(shipData)} m3/h`
        : "";
    case "Avg loading":
      return cargo.loadingLogRates?.avgRate
        ? `${cargo.loadingLogRates.avgRate} m3/h`
        : "";
    case "Pump capacity":
      return getShipPumpCapacity(shipData) || "";
    case "Deadweight":
      return getShipDeadWeight(shipData) || "";
    case "Manifolds":
      return cargo.loadingLogRates?.manifolds || "";
    case "Discharge port":
      return trip.to || "";
    case "Shore stops":
      return cargo.loadingLog?.[0]?.rate || "";
    case "Master":
      return trip.crew?.masterName || "";
    default:
      return ""; // Tomt för andra fält
  }
};

export default getPrefillValue;
